import type { TOC } from '@ember/component/template-only';
import LoanAccountDetail from 'tio-employee/components/accounts/loan-account-detail';
import type { LoanAccountDetailModel } from 'tio-employee/components/accounts/loan-account-detail';

interface Signature {
  Args: { model: LoanAccountDetailModel };
}

const template: TOC<Signature> = <template><LoanAccountDetail @model={{@model}} /></template>;

export default template;
